// extracted by mini-css-extract-plugin
export default {"App":"App_App__qmwK6","App-logo":"App_App-logo__RJw4l","App-logo-spin":"App_App-logo-spin__YDnRF","App-header":"App_App-header__Z+LSC","App-link":"App_App-link__dXyjy"};